import { __extends } from "tslib";
import { ErrorBase } from './ErrorBase';
/**
 * RangeError is thrown when an index is accessed out of range of the number of
 * available indices on an Array.
 */
var RangeError = /** @class */ (function (_super) {
    __extends(RangeError, _super);
    /**
     * Create a new RangeError.
     *
     * @param message An optional message to override the default error message.
     * @param id The id of the error.
     */
    function RangeError(message, id) {
        if (message === void 0) { message = null; }
        if (id === void 0) { id = 0; }
        return _super.call(this, message || 'RangeError', id) || this;
    }
    return RangeError;
}(ErrorBase));
export { RangeError };
